enum PayablesNewPayableReviewPayableActionType {
    PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_REQUEST_DATA = "PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_REQUEST_DATA",
    PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_LOAD_DATA = "PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_LOAD_DATA",
    PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_DISPLAY_ERROR = "PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_DISPLAY_ERROR",
    PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_LOAD_QUOTE = "PAYABLES_NEW_PAYABLE_REVIEW_PAYABLE_LOAD_QUOTE",
}

export default PayablesNewPayableReviewPayableActionType;